import React, { useEffect, useMemo, useState } from 'react';
import api from '../services/api';
import ReportPrintLayout from '../components/ReportPrintLayout';

const ReportsFinancialPrint = () => {
  const getCurrentMonthRange = useMemo(() => {
    const now = new Date();
    const start = new Date(now.getFullYear(), now.getMonth(), 1);
    const end = new Date(now.getFullYear(), now.getMonth() + 1, 0);
    const toISODate = (d) => {
      const y = d.getFullYear();
      const m = String(d.getMonth() + 1).padStart(2, '0');
      const day = String(d.getDate()).padStart(2, '0');
      return `${y}-${m}-${day}`;
    };
    return { start: toISODate(start), end: toISODate(end) };
  }, []);

  const [dateRange, setDateRange] = useState({ start: getCurrentMonthRange.start, end: getCurrentMonthRange.end });
  const [payload, setPayload] = useState(null);

  const fetchFinancialReport = async () => {
    try {
      const plRes = await api.get('/financial/summary/profit-loss', {
        params: { startDate: dateRange.start, endDate: dateRange.end },
      });
      const bsRes = await api.get('/financial/summary/balance-sheet', {
        params: { startDate: dateRange.start, endDate: dateRange.end },
      });

      setPayload({
        profit_loss: plRes.data || [],
        balance_sheet: bsRes.data || { cash_and_bank: 0, liabilities: 0, equity: 0 },
      });
    } catch (e) {
      setPayload(null);
    }
  };

  useEffect(() => {
    fetchFinancialReport();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dateRange.start, dateRange.end]);

  // Calculate summary values
  const plRows = payload?.profit_loss || [];
  const totalRevenue = plRows.reduce((s, r) => s + Number(r.total_revenue || 0), 0);
  const totalGrossProfit = plRows.reduce((s, r) => s + Number(r.gross_profit || 0), 0);
  const totalNetProfit = plRows.reduce((s, r) => s + Number(r.net_profit || 0), 0);
  const totalExpenses = plRows.reduce((s, r) => s + Number(r.total_expenses || 0), 0);

  // Prepare data for the print layout
  const printData = payload ? {
    summary: {
      total_revenue: totalRevenue,
      cogs: plRows.reduce((s, r) => s + Number(r.cogs || r.cost_of_goods_sold || 0), 0),
      gross_profit: totalGrossProfit,
      operating_expenses: totalExpenses,
      net_profit: totalNetProfit,
      profit_margin: totalRevenue > 0 ? (totalNetProfit / totalRevenue) * 100 : 0,
      vat_collected: 0,
      refunds: 0,
      discounts: 0,
    }
  } : null;

  return (
    <ReportPrintLayout
      reportData={printData}
      dateRange={dateRange}
      reportType="financial"
    />
  );
};

export default ReportsFinancialPrint;